import { CdkDrag } from '@angular/cdk/drag-drop';
import { NgStyle } from '@angular/common';
import { Component, computed, effect, ElementRef, input, output, viewChild } from '@angular/core';
import { ImageCardSettings } from '@app/features/operating-picture/map-wall-display/models/image-card-settings.model';

@Component({
    selector: 'topo-image-card',
    imports: [CdkDrag, NgStyle],
    templateUrl: './image-card.component.html',
    styleUrl: './image-card.component.scss'
})
export class ImageCardComponent {
  settings = input<ImageCardSettings>();
  dragBoundary = input<string>();
  parentContainerRect = input<DOMRect>();
  dragReleased = output();

  private container = viewChild<ElementRef<HTMLDivElement>>('container');

  styles = computed(() => {
    const { cardStyles, showBackground } = this.settings() ?? {};

    return {
      ...cardStyles,
      backgroundColor: showBackground ? cardStyles.backgroundColor : 'transparent'
    };
  });

  imageSrc = computed(() => this.settings()?.imageDataUrl);
  imageContainerPadding = computed(() => {
    const parentRect = this.parentContainerRect();
    return parentRect.height * 0.015;
  });

  settingsEffect = effect(() => {
    const { position, cardStyles } = this.settings();
    const containerEl = this.container().nativeElement;

    const { top, bottom, left, right } = position;

    if (top <= bottom) {
      containerEl.style.top = `${top}%`;
      containerEl.style.removeProperty('bottom');
    } else {
      containerEl.style.bottom = `${bottom}%`;
      containerEl.style.removeProperty('top');
    }
    if (left <= right) {
      containerEl.style.left = `${left}%`;
      containerEl.style.removeProperty('right');
    } else {
      containerEl.style.right = `${right}%`;
      containerEl.style.removeProperty('left');
    }

    // have to manually re-attach opacity on image card move because angular dnd cdk strips inline opacity value on drop event
    containerEl.style.opacity = cardStyles?.opacity ?? '1';
  });
}
